<div class="container-menu main-menu">
  <div class="container-logo">
    <a [href]="urlErp" target="blank">
      <img src="assets/images/logo-technoserver.jpeg" class="logo" alt="TechnoServer Soluções Inteligentes" />
    </a>
  </div>

  <div class="date">
    <span class="system-name">PDV Web</span>
    <span class="date-week text">{{ days[day.getDay()] }}</span>
    <span class="date-complet mb-2">{{ day | date : "dd/MM/yyyy" }}</span>
    <strong>versão {{ version }}</strong>
  </div>

  <nav class="navbar">
    <ul class="nav-menu">
      <li class="nav-menu-item">
        <a [href]="urlErp" target="blank" class="btn-erp">
          <i class="pi pi-desktop"></i>
          <span class="text">Ir para o ERP</span>
        </a>
      </li>

      <li class="nav-menu-item" routerLinkActive="active" *ngIf="!displayLogin">
        <a href="javascript:;" class="btn-sair" (click)="logout()">
          <i class="pi pi-sign-out"></i>
          <span class="text">Sair do PDV</span>
        </a>
      </li>

      <li class="nav-menu-item" routerLinkActive="active" *ngIf="!displayLogin">
        <a class="btn-icon btn-sell" routerLink="/pdv"><i class="pi pi-shopping-cart"></i><span>Vender</span></a>
      </li>

      <li class="nav-menu-item" routerLinkActive="active" *ngIf="!displayLogin">
        <a class="btn-icon btn-sales" routerLink="/sales"><i class="pi pi-tag"></i><span>Vendas</span></a>
      </li>

      <li class="nav-menu-item" routerLinkActive="active" *ngIf="!displayLogin">
        <a class="btn-icon btn-budget" routerLink="/budgets"><i class="pi pi-file"></i><span>Orçamento</span></a>
      </li>

      <li class="nav-menu-item" routerLinkActive="active" *ngIf="!displayLogin">
        <a class="btn-icon btn-financial" routerLink="/receipt"><i class="pi pi-wallet"></i><span>Recebimento</span></a>
      </li>

      <li class="nav-menu-item" routerLinkActive="active" *ngIf="!displayLogin">
        <a class="btn-icon btn-operations" routerLink="/operations"><i class="pi pi-cog"></i><span>Operações</span></a>
      </li>
    </ul>
  </nav>
</div>
